export enum WindowSize {
  XSmall,
  Small,
  Medium,
  Large,
  XLarge,
}

export enum ScreenSize {
  Xs = 'xs',
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
  Xl = 'xl',
}
